import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from '../axios';
import { fetchDoctors } from "../Actions";

import AdminSideBar from "./Adminsidebar";
import ClipLoader from "react-spinners/ClipLoader";
import searchIcon from "../Assets/images/sidebar/search.svg";
import plusicon from "../Assets/images/admindashboard/plusicon.png";
import phoneIcon from "../Assets/images/admindashboard/phoneIcon.png";
import emailIcon from "../Assets/images/admindashboard/emailIcon.png";
import personIcon from "../Assets/images/admindashboard/person.png";
import downloadbutton from '../Assets/images/admindashboard/downloadbutton.png'
import AdminNavbar from "./Adminsidebar";
import Topbar from "./Topbar";


const AgentsList = (props) => {
  const [loading, setLoading] = useState(true);
  const dataList = React.useMemo(
    () => props.doctors.doctors,
    [props.doctors.doctors]
    );
    
    const [searchText, setSearchText] = useState("");
    const [data, setData] = useState(dataList);

    const downloadData = (id,name) =>{
      axios
      .get(`/export-executive-data?doctorId=${id}`, {
        headers: { accessToken: localStorage.accessToken },
        responseType: 'blob'
      })
      .then((response) => {
        var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
            const fileName = 'AssessmentData - '+ name + "(" + date +').xlsx'
      console.log(response);
      console.log(response.data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  
    }
    useEffect(() => {
      props.fetchDoctors().then(() => setLoading(false));
      getDoctors().then(() => setLoading(false))
    }, []);

    const getDoctors = () => axios
    .get(`/getDoctors`, {
      headers: { accessToken: localStorage.accessToken },
    })
    .then((response) => {
      console.log(response)
      
      setData(response.data.data.users)
    
    })
  const excludeColumns = ["adminId", "role"];

  // const handleChange = (value) => {
  //   setSearchText(value);
  //   filterData(value);
  // };

  const filterData = () => {
    const lowercasedValue = searchText.toLowerCase().trim();
    if (!lowercasedValue) {
      setData(dataList);
    } else {
      const filteredData = dataList.filter((item) => {
        return Object.keys(item).some((key) => {
          return excludeColumns.includes(key)
            ? false
            : item[key]
            ? item[key].toString().toLowerCase().includes(lowercasedValue)
            : undefined;
        });
      });
      setData(filteredData);
    }
  };
  if(loading){
    return (
      <div className="loadingdiv">
      <ClipLoader color={"#fd8c00"} loading={loading} size={30} />
    </div>
    )
  }else

  return (
    <div className="dashboard">
      {/* <AdminNavbar agentslist /> */}
      {/* <AdminSideBar agentslist /> */}
      <div className="dashboard__content">
        <Topbar />
        <div className="patients__filters">
          <div className="patients__name-filter">
            <input
              type="text"
              placeholder="Search..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <button onClick={() => filterData()}>
              <img src={searchIcon} alt="search" />
            </button>
          </div>
        </div>
        <div className="dashboard__adminsummary">
          {data
            .filter(function (n) {
              return n.role !== "doctor";
            })
            .map((doctor, index) => {
              return (
                <div className="doctorcard" key={index}>
                  <div
                    className="doctorcard--info__content"
                    onClick={() => {
                      // props.filterEmail(doctor.loginId);
                      console.log(doctor.role);
                      props.history.push(`/patients/${doctor.loginId}`);
                      props.doctors.agentId = doctor.loginId;
                    }}
                  >
                    <p className="doctorcard--info__title">
                      {doctor.firstname ? doctor.firstname : null}
                    </p>
                    <img src={personIcon} alt="patients" />
                    <p className="doctorcard--info__count">
                      {doctor.qualifications ? doctor.qualifications : null}
                    </p>
                  </div>

                  <div className="doctorcard--info__logo">
                    <span>
                      <img src={plusicon} alt="patients" />
                    </span>
                    <span className="doctorcard--info__description">
                      {doctor.hospitals ? doctor.hospitals : null}
                    </span>
                  </div>

                  <div className="doctorcard--info__logo">
                    <span>
                      <img src={phoneIcon} alt="patients" />
                    </span>
                    <span className="doctorcard--info__description">
                      {doctor.contact ? doctor.contact : null}
                    </span>
                  </div>

                  <div className="doctorcard--info__logo">
                    <span>
                      <img src={emailIcon} alt="patients" />
                    </span>
                    <span className="doctorcard--info__description">
                      {doctor.loginId ? doctor.loginId : null}
                    </span>
                  </div>

                  {/* <div className="doctorcard--info__logo" onClick={() => downloadData(doctor.loginId)} style={{'cursor': "pointer"}}>
              <span><img src={downloadbutton} alt="downloadbutton" /></span>
              <span className="doctorcard--info__description" style={{"color":'blue'}} > 
              Download Excel Sheet
              </span>

            </div> */}

            <div className="doctorcard--info__logo">
              {/* <span><img src={emailIcon} alt="patients" /></span> */}
              <span className="doctorcard--info__title" > 
              Total Assessments : {doctor.assessmentCount ? doctor.assessmentCount : 0}
              <span onClick={() => downloadData(doctor.loginId,doctor.firstname)} ><img height={20} style={{"margin-left":'10%','cursor': "pointer"}} src={downloadbutton} alt="downloadbutton" /></span>

              </span>
            </div>

            
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  doctors: state.doctors,
});

export default connect(mapStateToProps, { fetchDoctors })(AgentsList);
